import React, { useCallback, useEffect, useRef, useState } from "react";

import { ReactComponent as AcePdgLogo } from "../assets/img/logo/acepdg-logo.svg";
import { ReactComponent as AcePdgLogoColored } from "../assets/img/logo/acepdg-logo-colored.svg";
import { ReactComponent as WingBookColored } from "../assets/img/logo/winged-book-colored.svg";

import { getStoreUrl } from "../helper/index";
import { useAppSelected, useIsMobile } from "../hooks/index";

export const Navigation = (props) => {
  const isMobile = useIsMobile();
  const appSelected = useAppSelected();

  const { whiteBg } = props;
  const [isHidden, setIsHidden] = useState(false);
  const prevScrollPos = useRef(0);

  let LogoIcon = AcePdgLogo;
  if (appSelected === "sjt") {
    LogoIcon = WingBookColored;
  } else if (whiteBg && !isMobile) {
    LogoIcon = AcePdgLogoColored;
  }

  // useEffect(() => {
  //   prevScrollPos.current = window.scrollY;

  //   const handleScroll = () => {
  //     const currentPos = window.scrollY;
  //     if (currentPos > prevScrollPos.current && currentPos > 80) {
  //       setIsHidden(true);
  //     } else if (currentPos < prevScrollPos.current) {
  //       setIsHidden(false);
  //     }
  //     prevScrollPos.current = currentPos;
  //   };

  //   window.addEventListener("scroll", handleScroll, { passive: true });
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);

  let classHide = isHidden && !whiteBg ? "menu-hide" : "";

  let classBg = whiteBg && !isMobile ? "menu-white" : "";

  let containerClass = appSelected === "sjt" ? "navbar-sjt" : "";
  let navSjtClass = appSelected === "sjt" ? "nav-sjt" : "";

  const hideBar = useCallback(() => {
    const pos =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    setIsHidden(pos > 120);
  }, []);

  useEffect(() => {
    document.body.addEventListener("scroll", hideBar, { passive: true });

    return () => {
      document.body.removeEventListener("scroll", hideBar);
    };
  }, [hideBar]);
  return (
    <nav
      id="menu"
      className={`navbar navbar-default navbar-fixed-top ${classBg}  ${navSjtClass} ${classHide}`}
    >
      <div className={`container no-overflow ${containerClass}`}>
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#navbar-collapse-home"
          >
            {" "}
            <span className="sr-only"></span> <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a
            className="navbar-brand page-scroll"
            href="# page-top"
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              textDecoration: "none",
            }}
          >
            {/* <PDGLogo style={{ height: 48, width: 48 }} /> */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <LogoIcon width={appSelected === "sjt" ? 98 : 144} />
              {/* Ace PDG
              <span>mobile app</span> */}
            </div>
          </a>{" "}
        </div>

        {isMobile && !whiteBg && (
          <div id="launch-date">
            <p>Available in Google Play and Apple App Store</p>
          </div>
        )}

        <div className="collapse navbar-collapse" id="navbar-collapse-home">
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a
                href={`/?app=${appSelected}`}
                data-toggle="collapse"
                data-target=".navbar-collapse"
              >
                Home
              </a>
            </li>
            <li role="presentation">
              <a
                role="presentation"
                id="app-menu"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="true"
              >
                Apps
                <span className="caret"></span>
              </a>
              <ul className="dropdown-menu" aria-labelledby="app-menu">
                <li>
                  <a href="?app=pdg">Ace PDG</a>
                </li>
                <li>
                  <a href="?app=sjt">Ace SJT</a>
                </li>
              </ul>
            </li>
            <li>
              <a
                href={
                  appSelected === "sjt" ? "/?app=sjt#footer" : "/?app=pdg#about"
                }
                className="page-scroll"
                data-toggle="collapse"
                data-target=".navbar-collapse"
              >
                About Us
              </a>
            </li>
            {appSelected !== "sjt" && (
              <li>
                <a
                  href="/#faq"
                  data-toggle="collapse"
                  data-target=".navbar-collapse"
                >
                  PFE FAQs
                </a>
              </li>
            )}

            <li>
              <a
                href={
                  appSelected === "sjt"
                    ? "/?app=sjt#quiz-mode"
                    : "/?app=pdg#about-services"
                }
                data-toggle="collapse"
                data-target=".navbar-collapse"
              >
                Services
              </a>
            </li>
            {/* <li>
              <a href="#App" className="page-scroll">
                APP
              </a>
            </li> */}

            {appSelected !== "sjt" && (
              <li>
                <a
                  href="/#contact"
                  data-toggle="collapse"
                  data-target=".navbar-collapse"
                >
                  Contact Us
                </a>
              </li>
            )}

            {appSelected !== "sjt" && (
              <li>
                <a
                  href="/contest-rules"
                  data-toggle="collapse"
                  data-target=".navbar-collapse"
                >
                  Contest Rules
                </a>
              </li>
            )}

            <li>
              <button
                onClick={() => {
                  window.open(getStoreUrl(appSelected), "_blank");
                }}
                className={`btn btn-custom btn-custom-primary ${
                  isMobile ? "ml-4" : ""
                }`}
              >
                {appSelected !== "sjt" ? "Start 3-days Trial" : "Try it Now"}
              </button>
            </li>

            {/* {isMobile && (
              <li>
                <div id="launch-date">
                  <p>
                    Available in App Store now, launching in Google Play store
                    soon!
                  </p>
                </div>
              </li>
            )} */}
          </ul>
        </div>
        {!isMobile && !whiteBg && (
          <div id="launch-date">
            <p>Available in Google Play and Apple App Store</p>
          </div>
        )}
      </div>
    </nav>
  );
};
